import {screenBaseUrl, hscreenBaseUrl,} from '../api'
export async function download(file, exterior = false) {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
        aLinkDownload(file.url, file.name); // IE浏览器
    } else if (navigator.userAgent.indexOf("Firefox") !== -1) {
        imageCanvasAlink(file.url, file.name); // 火狐浏览器
    } else if (navigator.userAgent.indexOf("Chrome") !== -1) {
        if (exterior) {
            window.open(hscreenBaseUrl + '/d/public/downLoad?filePath=' + encodeURIComponent(file.fileRealName) + '&fileName=' + file.name, '_blank');
        } else {
            window.open(screenBaseUrl + '/d/public/downLoad?filePath=' + encodeURIComponent(file.fileRealName) + '&fileName=' + file.name, '_blank');
        }
    } else {
        aLinkDownload(file.url, file.name);
    }
};

const aLinkDownload = (url, imgName) => {
    let a = document.createElement("a");
    let event = new MouseEvent("click");
    a.href = url;
    if (imgName) {
        a.download = imgName;
    } else {
        a.download = "down_load.jpg";
    }
    // a.click();火狐浏览器不触发
    a.dispatchEvent(event);
};
// 通过canvas转换
const imageCanvasAlink = (src, imgName) => {
    // 通过Images对象
    let image = new Image();
    image.setAttribute("crossOrigin", "use-credentials");
    image.onload = function (e) {
        let canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        let context = canvas.getContext("2d");
        context.drawImage(image, 0, 0, image.width, image.height);
        let url = canvas.toDataURL("image/png");
        let a = document.createElement("a");
        let event = new MouseEvent("click");
        if (imgName) {
            a.download = imgName;
        } else {
            a.download = "down_load.jpg";
        }
        a.href = url;
        // 触发a的单击事件
        a.dispatchEvent(event);
    };
    // 获取img上的src值，赋值之后，完成之后会调用onload事件
    image.src = src;
};
// 下载文件流的方式 火狐浏览器会默认XML格式，无法定义文件类型
const fileUrlDownload = async (url, imgName) => {
    /*let res = await axios({
     method: 'get',
     url: url,
     // timeout: 10000,
     withCredentials: true,
     responseType: 'blob' //定义接收类型
     });
     if (res.status === 200) {
     this.downFile(res.data, imgName); //下载文件
     }*/
    let xhr = new XMLHttpRequest();
    xhr.responseType = "blob"; // 返回类型blob流文件
    xhr.onload = function () {
        // 定义请求完成的处理函数
        if (this.status === 200) {
            let blob = this.response;
            let reader = new FileReader();
            reader.readAsDataURL(blob); // 转换为base64，可以直接放入a标签href
            reader.onload = function (e) {
                let a = document.createElement("a"); // 转换完成，创建一个a标签用于下载
                let event = new MouseEvent("click");
                if (imgName) {
                    a.download = imgName;
                } else {
                    a.download = "down_load.jpg";
                }
                a.href = e.target.result;
                a.dispatchEvent(event);
            };
        } else if (this.status === 504) {
            alert("导出失败，请求超时");
        } else {
            alert("导出失败");
        }
    };
    xhr.open("get", url, true);
    //此处为兼容后端中间件，设置请求头，文件格式
    //const a = hscreenBaseUrl.replace('/hmms','');
    const a = 'http://hmms.frp.gie360.com';
    //const a = 'http://localhost:3000';
    xhr.setRequestHeader(
        'Access-Control-Allow-Origin', '*'
        /* "Accept",
         "text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*!/!*;q=0.8,application/signed-exchange;v=b3"*/
    );
    debugger
    xhr.send();
};
const downFile = (data, name) => {
    debugger
    if (!data) {
        alert('数据错误！');
        return;
    }
    let BLOB = new Blob([data]);
    let url = window.URL.createObjectURL(BLOB);
    let link = document.createElement('a');
    link.style.display = 'none';
    link.href = url;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
};
